import React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
export var defaultSiteFooterConfig = {
  boundary: 'content'
};
export var SiteFooterContext = React.createContext(defaultSiteFooterConfig);
export var SiteFooterProvider = createInheritedProvider(SiteFooterContext);